export default "/static/dashboard/build/app/img/v2/97a80b1582a02955b1578a9760c4ace0.png";